import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Modalite, ModalitesService } from 'src/app/core/modalites.service';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FiltreService } from '../../filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-multiple-select-material-input',
  templateUrl: './multiple-select-material-input.component.html',
  styleUrls: ['../input/input.component.css']
})
export class MultipleSelectMaterialInputComponent extends InputComponent implements OnInit, OnDestroy {
  /**
   * Variables supplémentaires pour gérer l’affichage des choix faits dans un composant HTML
   */
  public listeSelectionnee: string = '';
  private modalites: Modalite[] = [];
  private subModalites: Subscription;

  /**
   * Nom d’une nomenclature qui peut être différente du nom du label à utiliser
   */
  @Input() nomNomenclature: string;
  modalites$: BehaviorSubject<Modalite[]>;
  constructor(
    protected modalitesService: ModalitesService,
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
  ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }
  ngOnInit() {
    super.ngOnInit();
    if (this.nomNomenclature) {
      // Si un nom de nomenclature est renseigné, on s’en sert pour récupérer les modalités
      this.modalites$ = this.modalitesService.getModalites(this.nomNomenclature);
    } else {
      this.modalites$ = this.modalitesService.getModalites(this.label);
    }
    this.modalites$.subscribe((modalites) => {
      this.modalites = modalites;
      // Permet de mettre à jour le tooltip une fois les modalités chargées
      this.currentControl.updateValueAndValidity();
    });
    this.currentControl.valueChanges.subscribe((valeur: Array<string>) => {
              this.listeSelectionnee = '';
              valeur.forEach((code) => {
                if (this.modalites.filter(value => value.code === code).length > 0) {
                  const libelle = this.modalites.filter(value => value.code === code)[0].libelle;
                  this.listeSelectionnee += `${libelle} — `;
                }
              });
              // Suppression de la virgule en trop
              if (this.listeSelectionnee.length > 0) {
                this.listeSelectionnee = this.listeSelectionnee.substring(0, this.listeSelectionnee.length - 3);
              }
    });
    this.currentControl.updateValueAndValidity();

  }
  ngOnDestroy() {
    // tslint:disable-next-line: curly
    if (this.subModalites && ! this.subModalites.closed) this.subModalites.unsubscribe();
  }

}
